/* eslint-disable @typescript-eslint/no-base-to-string */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import Axios from 'axios'
import { apiUrls, getParams, setAuthorizationHeaders, setHeaders } from '../utils'
import { getCoordinates } from '@/utils/getLatestLocation'

const { newOOBaseUrl } = apiUrls

interface HomeApiResponse<T = any> {
  data: T
  status: number
  statusText: string
  headers: any
  config: any
}

interface HomeApis {
  getSuperSavings: (params?: Record<string, any>) => Promise<HomeApiResponse>
  getFAQs: () => Promise<HomeApiResponse>
  getFAQDetails: (params?: Record<string, any>) => Promise<HomeApiResponse>
  getHome: (params?: { isUnifiedHome?: boolean }) => Promise<HomeApiResponse>
  getReferralCode: (customerId: string | number, params?: Record<string, any>) => Promise<HomeApiResponse>
  updateProfile: (data: Record<string, any>) => Promise<HomeApiResponse>
  getUnifiedBanner: (pageHome: string) => Promise<HomeApiResponse>
}

const homeApis: HomeApis = {
  getHome: async ({ isUnifiedHome } = {}) => {
    const storeProfile = `${newOOBaseUrl}customer/home`
    const {
      latitude,
      longitude
    } = getCoordinates()
    return await Axios({
      url: storeProfile,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        latitude,
        longitude,
        isUnifiedHome: true
      })
    })
  },

  getSuperSavings: async (params = {}) => {
    const superSavings = `${newOOBaseUrl}customer/super-savings`
    const {
      latitude,
      longitude
    } = getCoordinates()
    return await Axios({
      url: superSavings,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        ...params,
        latitude,
        longitude
      })
    })
  },

  getFAQs: async () => {
    const faqs = `${newOOBaseUrl}customer/aggregated-faq`
    const {
      latitude,
      longitude
    } = getCoordinates()
    return await Axios({
      url: faqs,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        latitude,
        longitude
      })
    })
  },

  getFAQDetails: async (params = {}) => {
    const faqDetails = `${newOOBaseUrl}customer/faq`
    return await Axios({
      url: faqDetails,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        ...params
      })
    })
  },

  getReferralCode: async (customerId, params = {}) => {
    const referralCode = `${newOOBaseUrl}customer/referral-code/${customerId ?? ''}`
    return await Axios({
      url: referralCode,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        ...params
      })
    })
  },

  updateProfile: async (data) => {
    const url = `${newOOBaseUrl}customer/profile`
    return await Axios({
      url,
      method: 'POST',
      data,
      headers: setHeaders(setAuthorizationHeaders())
    })
  },

  getUnifiedBanner: async (pageName = 'HOME') => {
    const {
      latitude,
      longitude
    } = getCoordinates()
    const url = `${newOOBaseUrl}customer/v2/home/unified-banner`
    return await Axios({
      url,
      method: 'GET',
      headers: setHeaders({
        ...setAuthorizationHeaders(),
        source: 'web_b2c'
      }),
      params: getParams({
        latitude,
        longitude,
        pageName
      })
    })
  }
}

export default homeApis
